import { useCallback, HTMLAttributes } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useStyles } from './consultation-modal.styles';
import { Modal, ResponsiveWidth } from '../../../../common';
import { ConsultationModalProps } from './consultation-modal.models';
import { Button } from '../../../../common/button-new';
import { formatPhoneNumberDisplay } from '../../../../../utils';
import { pushEcpLocatorEvent } from '../../../../../utils/analytics/push-ecp-locator-event';
import { EcpLocatorEvent } from '../../../../../models/ya-metrica-events';

export const ConsultationModal = ({ phone, code, onClose, ...props }: ConsultationModalProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  const handlePhoneClick = useCallback(() => {
    if (code) {
      pushEcpLocatorEvent(EcpLocatorEvent.CataractCall, code);
    }
    // Allow dataLayer event to be processed before tel: navigation
    setTimeout(() => {
      window.location.href = `tel:${phone}`;
    }, 0);
  }, [code, phone]);

  return (
    <Modal
      {...props}
      onClose={onClose}
      data-testid="ecp-cataract-modal"
      responsiveWidth={ResponsiveWidth.mdWide}
      propsPaperStyles={classes.paper}
      PaperProps={{ 'data-testid': 'ecp-cataract-modal-content' } as HTMLAttributes<HTMLDivElement>}
      title={intl.formatMessage({ id: 'ecp.cataract.title' })}
      titleStyles={classes.title}
      content={(
        <>
          <p
            className={classes.description}
            data-testid="ecp-cataract-modal-text"
          >
            <FormattedMessage id="ecp.cataract.text" />
          </p>
          <Button
            style="darker"
            testId="ecp-cataract-modal-button"
            rootClasses={classes.button}
            onClick={handlePhoneClick}
          >
            <FormattedMessage id="ecp.cataract.call" />
            {formatPhoneNumberDisplay(phone)}
          </Button>
        </>
      )}
    />
  );
};
